<template>
  <Section :content="digitalTwin" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'SectionDigitalTwin',
  components: {
    Section,
  },
  data() {
    return {
      digitalTwin: { 
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Digital Twin',
				headlineIcon: 'icon-digital-twin.png',
        paragraphs: [
          'Visualize system hierarchies, move between system ports and interfaces, find system linked documents, create new system structures.'
        ],
        id: 'digital-twin',
        image: 'digital-twin-screens.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-light-grad',
      },
    }
  }
};
</script>
